import axios from "axios";

export const recentOrders = (
  loginSuccesful,
  marketplace,
  key,
  setRecentlyOrderedProducts
) => {
  const requestData = {
    marketplace: marketplace,
    key: key,
  };

  if (loginSuccesful) {
    axios
      .post("/recently_ordered", requestData)
      .then((response) => {
        setRecentlyOrderedProducts(response.data.data.products);
      })
      .catch((err) => {
        console.log(
          "[recentOrders.actions.js] recentOrders || Could not fetch recent ordered. Try again later."
        );
      });
  } else {
    axios
      .post("/public_recently_ordered", requestData)
      .then((response) => {
        setRecentlyOrderedProducts(response.data.data.products);
      })
      .catch((err) => {
        console.log(
          "[recentOrders.actions.js] recentOrders || Could not fetch recent ordered. Try again later."
        );
      });
  }
};

export const newAssortment = (
  loginSuccesful,
  marketplace,
  key,
  setNewAssortmentProducts
) => {
  const requestData = {
    marketplace: marketplace,
    key: key,
  };

  if (loginSuccesful) {
    axios
      .post("/new_assortment", requestData)
      .then((response) => {
        setNewAssortmentProducts(response.data.data.products);
      })
      .catch((err) => {
        console.log(
          "[filteredResults.actions.js] newAssortment || Could not fetch new assortment. Try again later."
        );
      });
  } else {
    axios
      .post("/public_new_assortment", requestData)
      .then((response) => {
        setNewAssortmentProducts(response.data.data.products);
      })
      .catch((err) => {
        console.log(
          "[filteredResults.actions.js] newAssortment || Could not fetch new assortment. Try again later."
        );
      });
  }
};

export default { recentOrders, newAssortment };
